<div class="content-container">
	<div class="selection-diagram" *ngIf="diagramPath && displayDiagram">
		<cp-sb-selection-diagram [data]="data"
								 [diagramPath]="diagramPath"
								 (selectItem)="onSelect($event)">
		</cp-sb-selection-diagram>
	</div>

	<div class="selection-list" [cpTouchDrag] #list>
		<cp-sb-selection-list
			[data]="data"
			[subTitle]="subTitle"
			[itemTemplate]="itemTemplate"
			[searchTerms]="searchTerms"
			(actionClick)="onActionClick($event)"
			(selectItem)="onSelect($event)"
			(subTitleClick)="onSubTitleClick()">
		</cp-sb-selection-list>
	</div>

	<div *ngIf="!data || !data.length" class="no-data-wrapper">{{'NoDataToDisplay' | cpMessageTranslate}}</div>

</div>
